import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import { ModalBodyText } from "../../styles/modalTypography";
import { NextButton, SkipButton } from "../../styles/PersonalInfoStep";
import { GET } from "../../services/HTTPServices";
import { ALERT_TITLES } from "../../constants";
import { alertMessageWithCancel } from "../../services/alertService";
import {
  ErrorText,
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ReasonItem,
  StyledCheckbox,
  StyledFormControlLabel,
} from "../../styles/DeleteModal";

interface DeactivationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reasons: string[], emailPromos: boolean) => void;
}

const DeactivationModal: React.FC<DeactivationModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [selectedReasons, setSelectedReasons] = useState<any[]>([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [emailPromos, setEmailPromos] = useState(false);
  const [reasons, setReasons] = useState<any[]>([]);
  const [submitBtnClick, setSubmitBtnClick] = React.useState(false);

  useEffect(() => {
    getDataReasons();
  }, []);

  const getDataReasons = async () => {
    let res: any = await GET("dereason/GetDeReasonByType?type=1", "provider");
    if (res && res.data) {
      setReasons(res.data);
    }
  };
  const handleReasonToggle = (reason: any) => {
    setSelectedReasons((prev) =>
      prev.includes(reason)
        ? prev.filter((r) => r.id !== reason.id)
        : [...prev, reason]
    );
  };

  const handleDeactivate = async () => {
    setSubmitBtnClick(true);

    try {
      if (selectedReasons.length > 0) {
        onClose()
        const confirmLeave = await alertMessageWithCancel(
          ALERT_TITLES.INFO,
          "Are you sure to deactivate your account?"
        );
        if (confirmLeave) {
          setShowConfirmation(false);
          handleConfirm();
        }
      }
    } finally {
    }
  };

  const handleConfirm = () => {
    onConfirm(selectedReasons, emailPromos);
    onClose();
  };

  const handleBack = () => {
    if (showConfirmation) {
      setShowConfirmation(false);
    } else {
      setSelectedReasons([]);
      onClose();
    }
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContainer>
        {!showConfirmation ? (
          <>
            <ModalHeader>Let us know why you're taking a break?</ModalHeader>
            <ModalBody>
              <ModalBodyText>
                Please select at least one option to continue
              </ModalBodyText>

              {reasons.map((reason: any) => (
                <ReasonItem key={reason.id}>
                  <StyledFormControlLabel
                    control={
                      <StyledCheckbox
                        checked={
                          selectedReasons.findIndex(
                            (res: any) => res.id === reason.id
                          ) > -1
                        }
                        onChange={() => handleReasonToggle(reason)}
                        sx={{ "& .MuiSvgIcon-root": { color: "#76B041" } }}
                      />
                    }
                    label={
                      <ModalBodyText $margin="-4px 8px 0px 0px">
                        {reason.reason}
                      </ModalBodyText>
                    }
                  />
                </ReasonItem>
              ))}

              {submitBtnClick && selectedReasons.length === 0 && (
                <ErrorText>Please select at least one reason</ErrorText>
              )}
            </ModalBody>
            <ModalFooter>
              <SkipButton onClick={handleBack}>Cancel</SkipButton>
              <NextButton onClick={handleDeactivate}>Deactivate</NextButton>
            </ModalFooter>
          </>
        ) : (
          <>
            <ModalHeader>Your account has been deactivated.</ModalHeader>
            <ModalBody>
              <ModalBodyText>
                You can log back in anytime to reactivate it. See you soon!
              </ModalBodyText>

              <div className="mt-24">
                <StyledFormControlLabel
                  control={
                    <StyledCheckbox
                      checked={emailPromos}
                      onChange={(e) => setEmailPromos(e.target.checked)}
                    />
                  }
                  label={
                    <ModalBodyText>
                      Would you like us to e-mail tips & promos when you're
                      ready to come back?
                    </ModalBodyText>
                  }
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <NextButton $width="100%" onClick={handleConfirm}>
                Return to Home
              </NextButton>
            </ModalFooter>
          </>
        )}
      </ModalContainer>
    </Modal>
  );
};

export default DeactivationModal;
